if (!customElements.get('resin-safety-tabs')) {
  customElements.define('resin-safety-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.select(next, true);
        });
      });
      this.select(0);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
      if (focus) this.tabs[index]?.focus();
    }
  });
}

const initResinReveal = () => {
  const pages = document.querySelectorAll('.fa-resin-page');
  if (!pages.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  pages.forEach((page) => {
    if (page.dataset.resinRevealReady === 'true') return;
    page.dataset.resinRevealReady = 'true';
    page.classList.add('resin-effects-ready');

    const items = page.querySelectorAll('[data-resin-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initResinReveal, { once: true });
} else {
  initResinReveal();
}
